var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._g(_vm._b({attrs:{"items":_vm.items,"menu-props":{offsetY: true },"item-text":"kurumAdi","return-object":"","outlined":"","dense":""}},'v-select',[_vm.$props, _vm.$attrs],false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }